import { FLAVOR_DEVELOPMENT, FLAVOR_PRODUCTION } from './constants';
import { Flavor } from './types';
import { getPublicConfigFlavor } from './publicEnv';

const getFlavor = (): Flavor => {
  const fromEnv = getPublicConfigFlavor() as Flavor | undefined;
  if (fromEnv) {
    return fromEnv;
  }

  // Production builds historically omitted CONFIG_FLAVOR and meant production.
  if (import.meta.env.PROD) {
    return FLAVOR_PRODUCTION;
  }

  return FLAVOR_DEVELOPMENT;
};

export default getFlavor;
